import { IAbout } from "../interfaces/about.interface";
import { IRequest } from "../interfaces/authentication.interface";
import { ILegalResponse } from "../interfaces/legal.interface";
import { strapiRequest } from "./requests.service";

export const getAbout = async (locale: string): Promise<IRequest<IAbout>> => {
    try {
        const query = `
            query Content($locale: I18NLocaleCode) {
                aboutPageHr(locale: $locale) {
                    videoUrl
                    content
                    appstore_android
                    appstore_ios
                }
            }`;

        const variables = {
            locale
        };

        const response = await strapiRequest.post<{ data: { aboutPageHr: IAbout } }>(`/graphql`, {
            operationName: "Content",
            query,
            variables
        });
        
        return { success: true, data: response.data?.data.aboutPageHr ?? "" };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
